import xss from 'xss';
import { includes } from 'lodash';
// import Report from '@/utils/report';
// import SPM from '../../utils/spm';
// import { getSpmArr, goToOnClick } from '@/spm/spm.config';

// let removeListener;
// let handleClick;
// let exposurePage = [];

// const options = {
//   root: null, // 默认浏览器视窗
//   threshold: 0.5,
// };

// const sectionPrefixGetter = (modifiers) => {
//   const { warehouse, element } = modifiers;
//   let prefix = '';
//   if (warehouse) {
//     prefix = 'ecm_warehouse';
//   } else if (element) {
//     prefix = 'ecm_element';
//   } else {
//     prefix = 'chaos';
//   }

//   return prefix;
// };

// const spmDuration = {};

export default (Vue) => {
  // 处理元素级别埋点事件
  // Vue.directive('reportOld', {
  //   bind: (el, binding) => {
  //     const { exposure, click, duration, goTo } = binding.modifiers;
  //     // 监听曝光事件
  //     if (exposure) {
  //       const params = JSON.parse(binding.value);
  //       const { spmID } = params;
  //       exposurePage = getSpmArr().concat([]);
  //       spmDuration[spmID] = new SPM(Date.now());
  //       const callback = (entries) => {
  //         entries.forEach((entry) => {
  //           if (entry.isIntersecting && !duration) {
  //             const [cur, pre] = getSpmArr();
  //             const prefix = sectionPrefixGetter(binding.modifiers);

  //             const reportData = {
  //               chaos_pre_spm: pre ? pre.spm : '5.-2',
  //               chaos_cur_spm: cur ? `${cur.spm}.${spmID}` : '',
  //               ...params,
  //             };
  //             delete reportData.spmID;
  //             Report.Singleton.report(`${prefix}_impression`, reportData);
  //           }
  //         });
  //       };

  //       const observer = new IntersectionObserver(callback, options);
  //       const visuallyList = [];
  //       if (visuallyList.indexOf(binding.value) !== -1) {
  //         return;
  //       }

  //       observer.observe(el);

  //       removeListener = (ele) => {
  //         observer.unobserve(ele);
  //       };
  //     }

  //     // 监听点击
  //     if (click) {
  //       const params = JSON.parse(binding.value);
  //       const { spmID } = params;
  //       const [cur, pre] = getSpmArr();

  //       handleClick = (e) => {
  //         if (goTo) {
  //           goToOnClick(`${cur.spm}.${spmID}`);
  //         }

  //         e.stopPropagation();
  //         if (e && e.target) {
  //           const prefix = sectionPrefixGetter(binding.modifiers);
  //           const reportData = {
  //             chaos_pre_spm: pre ? pre.spm : '5.-2',
  //             chaos_cur_spm: cur ? `${cur.spm}.${spmID}` : '',
  //             ...params,
  //           };
  //           delete reportData.spmID;
  //           Report.Singleton.report(`${prefix}_click`, reportData);
  //         }
  //       };

  //       el.addEventListener('click', handleClick, false);
  //     }
  //   },
  //   unbind: (el, binding) => {
  //     removeListener(el);
  //     el.removeEventListener('click', handleClick);
  //     const { duration } = binding.modifiers;
  //     if (duration) {
  //       const [cur, pre] = exposurePage;
  //       const prefix = sectionPrefixGetter(binding.modifiers);

  //       const params = JSON.parse(binding.value);
  //       const { spmID } = params;
  //       const durationT = spmDuration[spmID].getDuration();
  //       const reportData = {
  //         chaos_pre_spm: pre ? pre.spm : '5.-2',
  //         chaos_cur_spm: cur ? `${cur.spm}.${spmID}` : '',
  //         duration: durationT,
  //         ...params,
  //       };
  //       delete reportData.spmID;
  //       Report.Singleton.report(`${prefix}_impression`, reportData);
  //     }
  //   },
  // });

  // 只能输入正整数
  Vue.directive('enterNumer', {
    inserted(el) {
      el.addEventListener('keypress', (e) => {
        // eslint-disable-next-line no-param-reassign
        e = e || window.event;
        const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
        const re = /\d/;
        if (
          !re.test(String.fromCharCode(charcode))
          && charcode > 9
          && !e.ctrlKey
        ) {
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
        }
      });
    },
  });

  // 输入框失焦时，去除所有空白字符
  Vue.directive('allTrim', {
    bind(ele) {
      const el = ele.tagName === 'INPUT' ? ele : ele.querySelector('input');
      el.addEventListener('blur', (e) => {
        // eslint-disable-next-line no-param-reassign
        e = e || window.event;
        e.target.value = e.target.value.replace(/\s*/g, '');
        el.dispatchEvent(new Event('input'));
      });
    },
  });

  // 点击输入框时，全选输入框内容
  Vue.directive('selectValue', {
    bind(ele) {
      const el = ele.tagName === 'INPUT' ? ele : ele.querySelector('input');
      el.addEventListener('click', (e) => {
        // eslint-disable-next-line no-param-reassign
        e = e || window.event;
        e.target.select();
      });
    },
  });

  // v-safe-html, 相当于过滤掉xss的 v-html
  Vue.directive(
    'safe-html',
    (ele, binding) => {
      const xssOptions = {
        // 被忽略标签 - 允许添加白名单属性
        onIgnoreTagAttr(tag, name, value) {
          const whiteAttrList = ['class', 'style'];
          if (includes(whiteAttrList, name)) {
            return `${name}="${xss.escapeAttrValue(value)}"`;
          }

          return '';
        },
        safeAttrValue(tag, name, value) {
          // 白名单属性
          const whiteAttrList = ['href', 'target', 'src', 'border'];
          if (includes(whiteAttrList, name)) {
            return `${xss.escapeAttrValue(value)}`;
          }

          return '';
        },
      };  // 自定义规则
      const myxss = new xss.FilterXSS(xssOptions);
      const safeHtml = myxss.process(binding.value);
      // eslint-disable-next-line no-param-reassign
      ele.innerHTML = safeHtml;
    },
  );
};
